import { IntentConfig } from 'src/shared/intent';

export const featureRegistry: Record<string, () => Promise<IntentConfig>> = {
  'connect': () => import('src/features/catalogItem').then((m) => m.catalogItemConnectIntentConfig),
  'payment-result': () => import('src/features/billing/lib/intents').then((m) => m.paymentResult),
  'subscribe': () => import('src/features/billing/lib/intents').then((m) => m.subscribeIntent),
} as const;
